import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import * as Yup from "yup";

// formik components
import { Formik, Form, Field } from "formik";
import Swal from "sweetalert2";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import { Box, CircularProgress, Dialog } from "@mui/material";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import { addNewCategoryApi, updateCategoryApi } from "api/categories";

function EventCategories({ openEventCategory, closeEventCategory, refreshData, isEdite, openModalItemData }) {
  const [isLoaded, setIsLoaded] = useState(false);

  const validationSchema = Yup.object().shape({
    eventCategory: Yup.string().required("Saisser le nom de nouvelle categorie"),
  });

  useEffect(() => {
    getInitialValue()
  }, [openModalItemData, isEdite])

  const getInitialValue = () => {
    try {
      if(isEdite) {
        
      }
    }
    catch (err) {
      console.log(err);
    }
  }

  const handleAddNewEventCategory = async (value) => {
    try {
      const formValues = {
        name: value.eventCategory
      }

      await addNewCategoryApi(formValues)
      Swal.fire({
        title: "Ajoutée",
        text: "",
        icon: "success"
      });

      refreshData()
      closeEventCategory();
    } catch (err) {
      console.log(err)
    }
  };

  const handleUpdateEventCategory = async (value) => {
    try {
      const formValues = {
        name: value.eventCategory
      }

      await updateCategoryApi(formValues, openModalItemData._id)
      Swal.fire({
        title: "Ajoutée",
        text: "",
        icon: "success"
      });

      refreshData()
      closeEventCategory();
    } catch (err) {
      console.log(err)
    }
  }

  return (
    <div>
      <Dialog open={openEventCategory} onClose={closeEventCategory} fullWidth maxWidth="sm">
        <MDBox>
          <Grid container justifyContent="center" alignItems="center" sx={{ height: "100%" }}>
            <Grid item xs={12}>
              <Formik
                initialValues={{
                  eventCategory: isEdite ? openModalItemData?.name : "",
                }}
                validationSchema={validationSchema}
                onSubmit={async (values) => {
                  isEdite ? handleUpdateEventCategory(values) : handleAddNewEventCategory(values)
                }}
              >
                <Form autoComplete="off">
                  <Card sx={{ height: "100%" }}>
                    <MDBox p={3}>
                      <MDBox>
                        <MDBox mb={1.625}>
                          <Grid container spacing={1}>
                            <Grid item xs={12} sm={12} mb={1.2}>
                              <Field name="eventCategory">
                                {({ field, meta }) => (
                                  <>
                                    <MDInput
                                      {...field}
                                      label="Nom de categories"
                                      size="large"
                                      fullWidth
                                      error={meta.error}
                                      success={!meta.error && meta.touched}
                                    />
                                    {meta.touched && meta.error && (
                                      <MDTypography
                                        component="div"
                                        variant="caption"
                                        color="error"
                                        fontWeight="regular"
                                      >
                                        {meta.error}
                                      </MDTypography>
                                    )}
                                  </>
                                )}
                              </Field>
                            </Grid>
                          </Grid>
                        </MDBox>
                        {isLoaded ? (
                          <Box sx={{ display: "flex" }}>
                            <CircularProgress />
                          </Box>
                        ) : (
                          <MDButton type="submit" variant="gradient" color="dark">
                            {isEdite ? "Modifier" : "Ajouter"}
                          </MDButton>
                        )}
                      </MDBox>
                    </MDBox>
                  </Card>
                </Form>
              </Formik>
            </Grid>
          </Grid>
        </MDBox>
      </Dialog>
    </div>
  );
}

EventCategories.propTypes = {
  openEventCategory: PropTypes.bool.isRequired,
  closeEventCategory: PropTypes.func.isRequired,
};

export default EventCategories;
